import { projectConversationPath, runPath } from "../routes/learningAgentPaths";

/** Where the run a review started lives. */
export const reviewRunHref = (
  result: { run_id: string | null; run_kind: string },
  projectId: string | null,
): string | null => {
  if (!result.run_id) return null;
  if (result.run_kind === "chat" && projectId) {
    return projectConversationPath(projectId, result.run_id);
  }
  return runPath(result.run_kind === "scheduled" ? "scheduled" : "conversations", result.run_id);
};

/** A review's conversation: with its project's conversations, or the team's for one on
 * no project (an answer about an agent's prompt). */
export const conversationHref = (
  conversationId: string | null,
  projectId: string | null,
): string | null => {
  if (!conversationId) return null;
  if (projectId) return projectConversationPath(projectId, conversationId);
  return reviewRunHref({ run_id: conversationId, run_kind: "agent_chat" }, null);
};
